"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.popupWidth = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _styleConsts = require("../utils/styleConsts");

var popupWidth = 375;
exports.popupWidth = popupWidth;
var appear =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("from{transform:scaleY(0)}to{transform:scaleY(100%)}");

var popupStyles = function popupStyles(placement, width) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;box-sizing:border-box;width:", width, "px;padding:8px 0px;z-index:1000;background-color:", _themeConfig.default.color.dark.mars, ";color:", _themeConfig.default.color.white, ";border-radius:", _styleConsts.borderRadius, ";box-shadow:0 12px 24px 0 rgba(34,47,66,0.1),0 1px 3px 0 rgba(34,47,66,0.15),0 1px 4px 0 rgba(0,0,0,0.16);transform-origin:top;animation:", appear, " 0.125s;::after{content:'';display:block;position:absolute;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:9px solid ", _themeConfig.default.color.dark.mars, ";top:-9px;", placement.includes('Right') ? "left: ".concat(width - 25, "px;") : 'left: 10px;', "}")
  );
};

var _default = popupStyles;
exports.default = _default;